import Moment from 'moment-timezone';
import { parseKeywords } from '@/utils/main';
import { BasicModel } from '@/models/BasicModel';

/**
 * Problem object
 */
export class Problem extends BasicModel {
  // Problem-specific properties
  id = 0;

  reportTeam = 0;

  affectTeam = 0;

  lWhat = '';

  lWho = '';

  lWhere = '';

  lWhen = '';

  lHow = '';

  lHowMuch = '';

  lWhy = '';

  impact = 0;

  deadline = null;

  leaders = [];

  archived = 0;

  archivedOn = null;

  completed = null;

  lastActionResolution = null;

  gwStep = 0;

  gwClItem = 0;

  created = null;

  endOfCreation = null;

  updated = null;

  recurrence = 0;

  // Built properties
  actions = [];

  files = [];

  zones = [];

  types = [];

  author = 0;

  /**
   * 1 : No causes, no actions.
   * 2 : Some causes, no actions.
   * 3 : Some actions, at least one action has pdca < 4.
   * 4 : Some actions, all of them have pdca = 4
   * @type {Number}
   */
  state = 0;

  /**
   * 1 => No securing actions.
   * 2 => Securing actions not started.
   * 3 => Ongoing securing actions.
   * 4 => Securing actions completed
   * @type {Number}
   */
  secuState = 0;

  status = [];

  keywords = [];

  indicators = [];

  wCauses = [];

  accesses = [];

  editableKeywords = '';

  nActions = 0;

  accessGranted = 0;

  // Sorting properties
  archiveDateSortable = '';

  createdSortable = '';

  deadlineSortable = '';

  latestUpdate = '';

  updateSortable = '';

  constructor(props, currentUser = null, autoFill = true) {
    super(props);
    this.setProps(props);
    if (autoFill) {
      this.created = this.created === null ? Moment().format('YYYY-MM-DD HH:mm:ss') : this.created;

      if (currentUser) {
        this.affectTeam = this.affectTeam === 0 ? currentUser.teamId : this.affectTeam;
        this.reportTeam = this.reportTeam === 0 ? currentUser.teamId : this.reportTeam;
      }
    }
  }

  setProps(props) {
    BasicModel.updateObjectProps(props, this);
  }

  /**
   * Return the params that should be used in the PUT /problems query to update a problem.
   * @return {Object}
   */
  get updateQueryParams() {
    const noTransformParams = [
      'lWhat',
      'lWho',
      'lWhere',
      'lWhen',
      'lHow',
      'lHowMuch',
      'lWhy',
      'impact',
      'files',
      'indicators',
      'types',
      'zones',
    ];
    const params = noTransformParams.reduce((all, param) => ({ ...all, [param]: this[param] }), {});
    params.keywords = parseKeywords(this.editableKeywords);
    if (this.deadline !== null) {
      params.deadline = this.deadline;
    }
    if (this.endOfCreation !== null) {
      params.endOfCreation = this.endOfCreation;
    }
    if (this.leaders.length > 0) {
      params.leaders = this.leaders;
    }
    return params;
  }
}

export default {
  Problem,
};
